/**
 * KAN-804: заголовок секции страницы итогов (эпик редизайна).
 *
 * Макет не использует шапки карточек: секции подписаны мелким прописным лейблом с
 * волосяной линией до края, а иногда — пояснением справа. Разница не косметическая.
 * `CardHeader` заявляет заголовок как объект интерфейса, вокруг которого рамка; здесь
 * подпись служебная и уступает содержимому — цифрам, ради которых страницу открыли.
 *
 * Отдельный компонент, а не копипаста в шести секциях: заголовки должны совпадать
 * между собой до пикселя, иначе страница рассыпается на разные блоки.
 */
export function SectionHeading({
  title,
  hint,
}: {
  title: string;
  /** Оговорка справа: «0–100», «балл — сводная оценка внутри роли». */
  hint?: string;
}) {
  return (
    <div className="mb-4 flex flex-wrap items-center gap-3">
      <span className="text-[11px] font-bold uppercase tracking-[0.12em] text-muted-foreground">
        {title}
      </span>
      <span className="h-px flex-1 bg-border" />
      {hint ? (
        <span className="text-[11px] text-muted-foreground">{hint}</span>
      ) : null}
    </div>
  );
}
